import React from 'react';
import styled from 'styled-components';

export const ChatWrapper = styled.div`
  position: relative;
  margin-bottom: 5vw;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const MessageWrapper = styled.div`
  margin-top: ${(props) => props.marginTop};
  position: relative;
  display: flex;
  align-items: center;
  width: 26.236vw;
  opacity: ${(props) => (props.hide ? '0' : '1')};
  visibility: ${(props) => (props.hide ? 'hidden' : 'visible')};
  transition: 200ms ease-in-out;
`;

export const Space = styled.div`
  width: ${(props) => props.width};
`;

export const StyledButton = styled.div`
  opacity: 0.5;
  color: ${(props) => props.theme.textPrimary};
  cursor: pointer;
  font-size: 0.728vw;
  &:hover {
    opacity: 1;
  }
`;

export const MessageName = styled.div`
  position: relative;
  color: ${(props) => props.theme.textPrimary};
  font-weight: bold;
  font-size: 0.728vw;
  flex: 1;
`;
export const MessageDate = styled.div`
  position: relative;
  color: ${(props) => props.theme.textPrimary};
  width: fit-content;
  font-weight: bold;
  font-size: 0.728vw;
`;

export const Content = styled.div`
  position: relative;
  /* top: 19.469vw; */
  left: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const OrderDetails = styled.div`
  position: relative;
  background-color: ${(props) => props.theme.cardBackground};
  width: 26.184vw;
  height: 12.255vw;
  font-size: 0.728vw;
  border-radius: 2.08vw;
  color: ${(props) => props.theme.textSecondary};
`;

export const OrderName = styled.div`
  width: 15vw;
  position: absolute;
  top: 1.56vw;
  left: ${(props) => (props.rtlDirection ? 'unset' : '1.56vw')};
  right: ${(props) => (!props.rtlDirection ? 'unset' : '1.56vw')};
  font-size: 1.04vw;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  color: ${(props) => props.theme.textPrimary};
`;

export const OrderItems = styled.div`
  position: absolute;
  top: 3.695vw;
  left: ${(props) => (props.rtlDirection ? 'unset' : '1.56vw')};
  right: ${(props) => (!props.rtlDirection ? 'unset' : '1.56vw')};
  display: flex;
  flex-direction: column;
`;

export const OrderItem = styled.div`
  margin-bottom: 0.5vw;
`;

export const OrderPrice = styled.div`
  position: absolute;
  right: ${(props) => (props.rtlDirection ? 'unset' : '1.56vw')};
  left: ${(props) => (!props.rtlDirection ? 'unset' : '1.56vw')};
  top: 4.528vw;
  font-size: 1.04vw;
  font-weight: bold;
  color: ${(props) => props.theme.textPrimary};
`;

export const StyledLine = styled.div`
  width: 26.184vw;
  height: 1px;
  position: relative;
  margin-top: 1.04vw;
  margin-bottom: 1.04vw;
  background-color: ${(props) => props.theme.cardBackground};
`;

export const StyledSubTitle = styled.div`
  width: 26.184vw;
  position: relative;
  font-size: 0.728vw;
  margin-bottom: 0.56vw;
  color: ${(props) => props.theme.textSecondary};
`;

export const HubSelctedWrapper = styled.div`
  width: 26.184vw;
  position: relative;
`;

export const Hub = styled.div`
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 26.184vw;
  height: 4.164vw;
  border-radius: 4.164vw;
  background-color: ${(props) => props.theme.cardOnCardBackground};
  padding-right: 1.56vw;
  box-sizing: border-box;
`;

export const HubName = styled.div`
  font-size: 0.937vw;
  font-weight: 500;
  color: ${(props) => props.theme.textPrimary};
  margin-left: 1.56vw;
`;

export const HubSelctionWrapper = styled.div`
  position: relative;
  padding-top: 2.342vw;
  padding-bottom: 2.328vw;
`;

export const TrackingNumberWrapper = styled.div`
  position: relative;
  /* margin-top: 19.469vw; */
  padding-top: 2.342vw;
  padding-bottom: 2.328vw;
`;

export const DeliveryBox = styled.div`
  width: 26.236vw;
  height: 5.517vw;
  border-radius: 1.56vw;
  box-sizing: border-box;
  margin-top: 1.04vw;
  margin-bottom: 3.409vw;
  margin-left: 6.923vw;
  position: relative;
  background-color: ${(props) => (props.selected ? props.theme.pure : props.theme.cardBackground)};
  border: ${(props) => (props.selected ? '2px' : '0')} solid
    ${(props) => props.theme.borderBackground};
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: 200ms linear;
  &:hover {
    background-color: ${(props) =>
      props.selected ? props.theme.pure : props.theme.cardOnCardBackground};
  }
`;

export const StyledName = styled.div`
  position: relative;
  width: ${(props) => (props.width ? props.width : 'unset')};
  font-size: ${(props) => (props.fontSize ? props.fontSize : '1.145vw')};
  font-weight: 500;
  color: ${(props) => props.theme.textPrimary};
`;

export const StyledAddress = styled.div`
  position: absolute;
  top: 1.56vw;
  right: 1.04vw;
  font-size: 0.832vw;
  font-weight: 500;
  color: ${(props) => props.theme.textPrimary};
`;

export const StyledOpenHours = styled.div`
  position: absolute;
  bottom: 1.56vw;
  right: 1.04vw;
  font-size: 0.624vw;
  font-weight: 500;
  color: ${(props) => props.theme.textSecondary};
`;

export const TrackingNumberTitle = styled.div`
  position: relative;
  font-size: 1.249vw;
  font-weight: bold;
  margin-top: 2.19vw;
  margin-left: 6.923vw;
  color: ${(props) => props.theme.textPrimary};
`;

export const TrackingNumberText = styled.div`
  position: relative;
  font-size: 0.937vw;
  margin-top: 1.56vw;
  margin-left: 6.923vw;
  width: 26.236vw;
  color: ${(props) => props.theme.textSecondary};
`;

export const InputWrapper = styled.div`
  position: relative;
  margin-left: 6.923vw;
`;

export const CheckBoxWrapper = styled.div`
  position: relative;
  width: 100%;
  font-size: 1.04vw;
  margin-top: 1.04vw;
  margin-left: 6.923vw;
  /* border-top: 1px solid #51535a; */
  display: flex;
  align-items: center;
  color: ${(props) => props.theme.textSecondary};
`;

export const ButtonsWrapper = styled.div`
  position: absolute;
  top: 4.997vw;
  right: 1.301vw;
  width: 10.411vw;
  /* border-top: 1px solid #51535a; */
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const OrderBody = styled.div`
  position: relative;
  width: 100%;
  margin-top: 19.469vw;
`;

export const OrderBodyHelper = styled.div`
  position: relative;
  width: 28.266vw;
`;

export const DownloadWrapper = styled.div`
  position: absolute;
  right: ${(props) => (props.rtlDirection ? 'unset' : '1.56vw')};
  left: ${(props) => (!props.rtlDirection ? 'unset' : '1.56vw')};
  top: ${(props) => props.top? props.top+'vw' : '6.54vw'};
  width: 2.08vw;
  height: 2.08vw;
  background-color: ${(props) => props.theme.inputBackground + '00'};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: 200ms linear;
  transition: 200ms ease-in-out;
  &:hover {
    background-color: ${(props) => props.theme.inputBackground};
  }
`;

export const DownloadIcon = styled.div`
  width: 1.1vw;
  height: 1.1vw;
  position: relative;
  transition: background-color 200ms linear;

  align-items: center;
  display: flex;
  justify-content: center;
  color: ${(props) => props.theme.icons};
  font-size: 1.2vw;
`;